module.exports = __webpack_public_path__ + "static/screenshot1-c8f85d97f76f3658b0720724646424e8.png";